<div class="cell" *ngIf="source === 'email'">
  <app-top-bar></app-top-bar>
</div>
<div class="cell info-bar">
  <app-eeoc-info-bar></app-eeoc-info-bar>
</div>
<div *ngIf="displayForm === true" class="grid-y" class="main-container eeoc-container">
  <form [formGroup]="formGroup">
    <div class="grid-y form-container grid-padding-y">
      <div class="cell" *ngIf="source === 'email'">
        <h1>{{"eeoc-form.thanks" | translate:{name: talentName} }}</h1>
      </div>
      <div class="cell" *ngIf="source === 'gather'">
        <h1>{{"eeoc-form.fostering-a-diverse" | translate}}</h1>
        <p>{{"eeoc-form.fostering-a-diverse-subtext" | translate}}</p>
      </div>
      <div class="cell" id="eeoc-header">
        <h2>{{"eeoc-form.equal-opportunity-header" | translate}}</h2>
        <p class="prewrap" innerHTML="{{'eeoc-form.equal-opportunity-subtext' | translate}}"></p>
      </div>
      <div class="cell" *ngIf="talentCountryId === country.USA">
        <p id="contact-us">
          {{"eeoc-form.contact-us.text_part1" | translate}}
          <a href="mailto:compliance@aquent.com">{{"eeoc-form.contact-us.mailto" | translate}}</a>
          {{"eeoc-form.contact-us.text_part2" | translate}}
          <a href="https://www.dol.gov/sites/dolgov/files/ofccp/regs/compliance/posters/pdf/eeopost.pdf" target="_blank">
            {{"eeoc-form.contact-us.link-text" | translate}}
          </a>
        </p>
      </div>
      <div class="cell" id="using-data">
        <h2>{{"eeoc-form.using-data.header" | translate}}</h2>
        <p class="prewrap" innerHTML="{{'eeoc-form.using-data.subtext' | translate}}"></p>
      </div>
      <div class="cell top-section">
        <div class="grid-x">
          <div class="small-12 medium-4 invalid-spacer"></div>
          <div *ngIf="submitted && !formControls.gender.valid" class="cell small-12 medium-4 invalid-feedback">
            {{"eeoc-form.error" | translate:{fieldName: "eeoc-form.gender" | translate} }}
          </div>
        </div>
        <div class="grid-x">
          <div class="cell small-12 medium-4 eeoc-label">
            <span>{{"eeoc-form.gender" | translate}}</span>
          </div>
          <div class="cell small-12 medium-4">
            <app-dropdown-box [dropdownBoxId]="'genderSelect'"
                              [invalid]="submitted && !formControls.gender.valid"
                              [formControlName]="'gender'"
                              [options]="genderOptions"
                              (valueChanged)="validateForm()">
            </app-dropdown-box>
            <div style="width:100%" *ngIf="formControls.gender.value == GENDER_OTHER_ID">
              <input formControlName="customGender" id="custom-gender-input" type="text" placeholder="Please specify" class="gender-other-input">
            </div>
          </div>
        </div>
      </div>
      <div class="cell">
        <div class="grid-x">
          <div class="small-12 medium-4 invalid-spacer"></div>
          <div *ngIf="submitted && !formControls.lgbtq.valid" class="cell small-12 medium-4 invalid-feedback">
            {{"eeoc-form.error" | translate:{fieldName: "eeoc-form.lgbtq" | translate} }}
          </div>
        </div>
        <div class="grid-x ">
          <div class="cell small-12 medium-4 eeoc-label" (clickOutside)="changeDetailsBoxVisibility('lgbtq', true)">
            <span>{{"eeoc-form.lgbtq" | translate}}</span>
            <a *ngIf="talentCountryId === country.USA" class="details" (click)="changeDetailsBoxVisibility('lgbtq', !hideLgbtqDetails)">
              {{"eeoc-form.details" | translate}}
            </a>
            <app-details-box id="lgbtq-details"
                             class="details-box"
                             *ngIf="!hideLgbtqDetails"
                             [forceSingleColumnTooltip]="true"
                             [detailsName]="'lgbtq'">
            </app-details-box>
          </div>
          <div class="cell small-12 medium-4">
            <mat-radio-group formControlName="lgbtq">
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="lgbtqYes"
                                  id="lgbtq-yes" [value]="1"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.lgbtq.valid)}" >{{"yes" | translate}}
                </mat-radio-button>
              </div>
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="lgbtqNo"
                                  id="lgbtq-no" [value]="2"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.lgbtq.valid)}" >{{"no" | translate}}
                </mat-radio-button>
              </div>
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="lgbtqNoAnswer"
                                  id="lgbtq-no-answer" [value]="3"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.lgbtq.valid)}">{{"eeoc-form.do-not-wish-to-answer" | translate}}
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="cell">
        <div class="grid-x">
          <div class="small-12 medium-4 invalid-spacer"></div>
          <div *ngIf="submitted && !formControls.ethnicity.valid" class="cell small-12 medium-4 invalid-feedback">
            {{"eeoc-form.error" | translate:{fieldName: "eeoc-form.ethnicity" | translate} }}
          </div>
        </div>
        <div class="grid-x">
          <div class="cell small-12 medium-4 eeoc-label" (clickOutside)="changeDetailsBoxVisibility('ethnicity', true)">
            <span>{{"eeoc-form.ethnicity" | translate}}</span>
            <a *ngIf="talentCountryId === country.USA" class="details" (click)="changeDetailsBoxVisibility('ethnicity', !hideEthnicityDetails)">
              {{"eeoc-form.details" | translate}}
            </a>
            <app-details-box id="ethnicity-details"
                             class="details-box"
                             *ngIf="!hideEthnicityDetails"
                             [detailsName]="'ethnicity'">
            </app-details-box>
          </div>
          <div class="cell small-12 medium-4">
            <app-dropdown-box formControlName="ethnicity"
                              [dropdownBoxId]="'ethnicitySelect'"
                              [invalid]="submitted && !formControls.ethnicity.valid"
                              [options]="ethnicityOptions"
                              (valueChanged)="validateForm()">
            </app-dropdown-box>
          </div>
        </div>
      </div>
      <div class="cell top-section" *ngIf="ageGroupFeature">
        <div class="grid-x">
          <div class="small-12 medium-4 invalid-spacer"></div>
          <div *ngIf="submitted && !formControls.ageGroup.valid" class="cell small-12 medium-4 invalid-feedback">
            {{"eeoc-form.error" | translate:{fieldName: "eeoc-form.age-group" | translate} }}
          </div>
        </div>
        <div class="grid-x">
          <div class="cell small-12 medium-4 eeoc-label">
            <span>{{"eeoc-form.age-group" | translate}}</span>
          </div>
          <div class="cell small-12 medium-4">
            <app-dropdown-box formControlName="ageGroup"
                              [dropdownBoxId]="'ageGroupSelect'"
                              [invalid]="submitted && !formControls.ageGroup.valid"
                              [options]="ageGroupOptions"
                              (valueChanged)="validateForm()">
            </app-dropdown-box>
          </div>
        </div>
      </div>
      <div class="cell form-group" *ngIf="talentCountryId === country.USA">
        <div class="grid-x">
          <div class="small-12 medium-4 invalid-spacer"></div>
          <div *ngIf="submitted && !formControls.veteranIdentification.valid" class="cell small-12 medium-4 invalid-feedback">
            {{"eeoc-form.error" | translate:{fieldName: "eeoc-form.veteran-status" | translate} }}
          </div>
        </div>
        <div class="grid-x ">
          <div class="cell small-12 medium-4 eeoc-label" (clickOutside)="changeDetailsBoxVisibility('veteran', true)">
            <span>{{"eeoc-form.veteran-status" | translate}}</span>
            <a *ngIf="talentCountryId === country.USA" class="details" (click)="changeDetailsBoxVisibility('veteran', !hideVeteranDetails)">
              {{"eeoc-form.details" | translate}}
            </a>
            <app-details-box id="veteran-details" class="details-box"
                             *ngIf="!hideVeteranDetails"
                             [detailsName]="'veteran'">
            </app-details-box>
          </div>
          <div class="cell small-12 medium-4">
            <mat-radio-group formControlName="veteranIdentification">
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="veteranYes"
                                  id="veteran-yes" [value]="1"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.veteranIdentification.valid), 'mat-context': source === 'mat'}" >{{"yes" | translate}}
                </mat-radio-button>
              </div>
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="veteranNo"
                                  id="veteran-no" [value]="2"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.veteranIdentification.valid), 'mat-context': source === 'mat'}" >{{"no" | translate}}
                </mat-radio-button>
              </div>
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="veteranNoAnswer"
                                  id="veteran-no-answer" [value]="3"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.veteranIdentification.valid), 'mat-context': source === 'mat'}" >{{"eeoc-form.do-not-wish-to-answer" | translate}}
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="cell">
        <div class="grid-x">
          <div class="small-12 medium-4 invalid-spacer"></div>
          <div *ngIf="submitted && !formControls.selfIdentificationDisability.valid" class="cell small-12 medium-4 invalid-feedback">
            {{"eeoc-form.error" | translate:{fieldName: "eeoc-form.self-identification-disability" | translate} }}
          </div>
        </div>
        <div class="grid-x ">
          <div [ngClass]="talentCountryId !== country.USA ? 'cell small-11 medium-3 eeoc-label' : 'cell small-12 medium-4 eeoc-label'" (clickOutside)="changeDetailsBoxVisibility('disability', true)">
            <span>{{"eeoc-form.self-identification-disability" | translate}}</span>
            <a *ngIf="talentCountryId === country.USA" class="details" (click)="changeDetailsBoxVisibility('disability', !hideDisabilityDetails)">
              {{"eeoc-form.details" | translate}}
            </a>
            <app-details-box id="disability-details" class="details-box"
                             *ngIf="!hideDisabilityDetails"
                             [header]="'eeoc-form.disability-header' | translate"
                             [detailsName]="'disability'">
            </app-details-box>
          </div>
          <div *ngIf="talentCountryId !== country.USA" class="small-1 medium-1 "></div>
          <div class="cell small-12 medium-4">
            <mat-radio-group formControlName="selfIdentificationDisability">
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="selfIdentificationDisabilityYes"
                                  id="self-disability-identification-yes" [value]="1"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.selfIdentificationDisability.valid), 'mat-context': source === 'mat'}" >{{"eeoc-form.disability-yes" | translate}}
                </mat-radio-button>
              </div>
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="selfIdentificationDisabilityNo"
                                  id="self-disability-identification-no" [value]="2"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.selfIdentificationDisability.valid), 'mat-context': source === 'mat'}" >{{"eeoc-form.disability-no" | translate}}
                </mat-radio-button>
              </div>
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="selfIdentificationDisabilityNoAnswer"
                                  id="self-disability-identification-no-answer" [value]="3"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.selfIdentificationDisability.valid), 'mat-context': source === 'mat'}" >{{"eeoc-form.do-not-wish-to-answer" | translate}}
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="cell">
        <div class="grid-x">
          <div class="small-12 medium-4 invalid-spacer"></div>
          <div *ngIf="submitted && !formControls.neurodivergent.valid" class="cell small-12 medium-4 invalid-feedback">
            {{"eeoc-form.error" | translate:{fieldName: "eeoc-form.neurodivergent" | translate} }}
          </div>
        </div>
        <div class="grid-x ">
          <div class="cell small-12 medium-4 eeoc-label" (clickOutside)="changeDetailsBoxVisibility('neurodivergent', true)">
            <span>{{"eeoc-form.neurodivergent" | translate}}</span>
            <a *ngIf="talentCountryId === country.USA" class="details" (click)="changeDetailsBoxVisibility('neurodivergent', !hideNeuroDetails)">
              {{"eeoc-form.details" | translate}}
            </a>
            <app-details-box id="neurodivergent-details"
                             class="details-box"
                             *ngIf="!hideNeuroDetails"
                             [forceSingleColumnTooltip]="true"
                             [detailsName]="'neurodivergent'">
            </app-details-box>
          </div>
          <div class="cell small-12 medium-4">
            <mat-radio-group formControlName="neurodivergent">
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="neurodivergentYes"
                                  id="neruodivergent-yes" [value]="1"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.neurodivergent.valid), 'mat-context': source === 'mat'}" >{{"yes" | translate}}
                </mat-radio-button>
              </div>
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="neurodivergentNo"
                                  id="neurodivergent-no" [value]="2"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.neurodivergent.valid), 'mat-context': source === 'mat'}" >{{"no" | translate}}
                </mat-radio-button>
              </div>
              <div class="cell">
                <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                  name="neurodivergentNoAnswer"
                                  id="neurodivergent-no-answer" [value]="3"
                                  [ngClass]="{'invalid-text': (submitted && !formControls.neurodivergent.valid), 'mat-context': source === 'mat'}" >{{"eeoc-form.do-not-wish-to-answer" | translate}}
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div *ngIf="talentCountryId === country.USA" id="immagrationSection">
        <div class="cell">
          <h2 id="immigrationHeader">{{"eeoc-form.immigration-header" | translate}}</h2>
        </div>
        <div class="cell">
          <div class="grid-x">
            <div class="small-12 medium-4 invalid-spacer"></div>
            <div *ngIf="submitted && !formControls.authorizedToWorkInUS.valid" class="cell small-12 medium-4 invalid-feedback">
              {{"eeoc-form.error-immigration" | translate}}
            </div>
          </div>
          <div class="grid-x ">
            <div class="cell small-12 medium-4 eeoc-label">
              <span>{{"eeoc-form.authorized-to-work" | translate}}</span>
            </div>
            <div class="cell small-12 medium-4">

              <mat-radio-group formControlName="authorizedToWorkInUS">
                <div class="cell">
                  <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                    name="authorizedToWorkInUSYes"
                                    id="authorize-to-work-us-yes" [value]="true"
                                    [ngClass]="{'invalid-text': (submitted && !formControls.authorizedToWorkInUS.valid), 'mat-context': source === 'mat'}" >{{"yes" | translate}}
                  </mat-radio-button>
                </div>
                <div class="cell">
                  <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                    name="authorizedToWorkInUSNo"
                                    id="authorize-to-work-us-no" [value]="false"
                                    [ngClass]="{'invalid-text': (submitted && !formControls.authorizedToWorkInUS.valid), 'mat-context': source === 'mat'}" >{{"no" | translate}}
                  </mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </div>
        </div>
        <div class="cell">
          <div class="grid-x">
            <div class="small-12 medium-4 invalid-spacer"></div>
            <div *ngIf="submitted && !formControls.requiresSponsorship.valid" class="cell small-12 medium-4 invalid-feedback">
              {{"eeoc-form.error-immigration" | translate}}
            </div>
          </div>
          <div class="grid-x">
            <div id="requiresSponsorship" class="cell small-12 medium-4 eeoc-label">
              <span>{{"eeoc-form.require-sponsorship" | translate}}</span>
            </div>
            <div class="cell small-12 medium-4">
              <mat-radio-group formControlName="requiresSponsorship">
                <div class="cell">
                  <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                    name="requiresSponsorshipYes"
                                    id="requires-sponsorship-yes" [value]="true"
                                    [ngClass]="{'invalid-text': (submitted && !formControls.requiresSponsorship.valid), 'mat-context': source === 'mat'}" >{{"yes" | translate}}
                  </mat-radio-button>
                </div>
                <div class="cell">
                  <mat-radio-button color="primary" [disableRipple]="true" color="primary"
                                    name="requiresSponsorshipNo"
                                    id="requires-sponsorship-no" [value]="false"
                                    [ngClass]="{'invalid-text': (submitted && !formControls.requiresSponsorship.valid), 'mat-context': source === 'mat'}" >{{"no" | translate}}
                  </mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div class="cell">
        <button type="button" class="button submit submit-button" (click)="submitEeoc()" href="#">{{"submit" | translate}}</button>
      </div>
    </div>
  </form>
  <app-modal id="eeocDeleteModal" class="mat">
    <div class="content">
      <h1 id="eeoc-delete-modal-header" class="delete-header">{{"eeoc-form.delete-modal.title" | translate}}</h1>
      <p id="eeoc-delete-modal-content" innerHTML="{{'eeoc-form.delete-modal.content' | translate}}">
    </div>
    <hr>
    <div class="modal-button-bar">
      <button id="eeoc-delete-modal-close-button" type="button" class="button submit submit-button" (click)="closeDeleteEeocModal()">{{"eeoc-form.delete-modal.button-text" | translate}}</button>
    </div>
  </app-modal>
  <span data-iframe-height></span>
</div>
